var React = require('react');

function IconPilotight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M258.9 128.3c0-35.6 29-64.4 63.8-64.4h384.2c35.2 0 63.8 28.8 63.8 64.4v766.9c0 35.6-29 64.4-63.8 64.4H322.7c-35.2 0-63.8-28.8-63.8-64.4V128.3zm258.7 230.1c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4 36.5 81.4 81.4 81.4zm-1.2 234.5c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4 36.4 81.4 81.4 81.4zm-2 237.1c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4c0 45 36.4 81.4 81.4 81.4z"}));
}

IconPilotight.displayName = "IconPilotight";

IconPilotight.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPilotight;

IconPilotight.default = IconPilotight;
